import { render, staticRenderFns } from "./TabError.vue?vue&type=template&id=1b3496ef&scoped=true&"
import script from "./TabError.vue?vue&type=script&lang=ts&"
export * from "./TabError.vue?vue&type=script&lang=ts&"
import style0 from "./TabError.vue?vue&type=style&index=0&id=1b3496ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3496ef",
  null
  
)

export default component.exports